import { render, staticRenderFns } from "./ProductPortal.vue?vue&type=template&id=762f92c2&"
import script from "./ProductPortal.vue?vue&type=script&lang=js&"
export * from "./ProductPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports